module.exports = __webpack_public_path__ + "img/vertical_7_3_3016.5f3623e3.png";